import type * as React from 'react';

import type { HNCoreFrontendWebForside } from '../types/Resources';

import NotificationPanel from '@helsenorge/designsystem-react/components/NotificationPanel';

import SafeHTML, { type MarkdownType } from '@helsenorge/framework-utils/components/safe-html';

import NotificationPanelWrapper from '../notificationpanel-wrapper';

import styles from './styles.module.scss';

interface ExpanderWarningProps {
  label: string;
  html: string | MarkdownType;
  resources: HNCoreFrontendWebForside;
  testId?: string;
}

const ExpanderWarning: React.FC<ExpanderWarningProps> = props => {
  return (
    <NotificationPanelWrapper>
      <NotificationPanel
        variant="info"
        size="large"
        testId={props.testId}
        label={props.label}
        expanderButtonText={props.resources.se_mindre}
        expanderButtonClosedText={props.resources.se_mer}
        expanderChildren={<SafeHTML html={props.html} tagName="div" className={styles['message-content']} type={'markdown'} />}
      />
    </NotificationPanelWrapper>
  );
};

export default ExpanderWarning;
